var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortTableDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50994 19.207C6.31994 19.207 6.12994 19.137 5.97994 18.987L0.969941 13.977C0.679941 13.687 0.679941 13.207 0.969941 12.917C1.25994 12.627 1.73994 12.627 2.02994 12.917L7.03994 17.927C7.32994 18.217 7.32994 18.697 7.03994 18.987C6.88994 19.127 6.69994 19.207 6.50994 19.207Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51001 19.207C6.10001 19.207 5.76001 18.867 5.76001 18.457V1.45703C5.76001 1.04703 6.10001 0.707031 6.51001 0.707031C6.92001 0.707031 7.26001 1.04703 7.26001 1.45703V18.457C7.26001 18.867 6.92001 19.207 6.51001 19.207Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortTableDesc);
export default __webpack_public_path__ + "static/media/sort-table-desc.bac9e0760065509f17f3bf31109bee4d.svg";
export { ForwardRef as ReactComponent };